import { RemoteAuthenticationLogout } from 'data/usecases';
import { AuthenticationLogoutUseCaseInterface } from 'domain/usecases/authentication/authentication-logout';
import { makeApiUrlAuthenticationLogout } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteAuthenticationLogout =
  (): AuthenticationLogoutUseCaseInterface => {
    return new RemoteAuthenticationLogout(
      makeApiUrlAuthenticationLogout(),
      makeAxiosHttpClient(),
    );
  };
